export default __webpack_public_path__ + "static/media/noti1.90a32eba.mp3";